
import {filter} from 'rxjs/operators';

import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
    selector: 'hub-breadcrumb',
    templateUrl: './hub-breadcrumb.component.html',
})

export class BreadcrumbComponent implements OnInit {

    @Input() public showTitle: boolean = false;
    @Input() public setBreadcrumsbManually: any[];

    public title: any;
    public breadcrumbs: any[];
    public lastBreadLink: string;
    public breadLabelCount: number = 0;

    private uri = window.location.href;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
    ) { }

    public ngOnInit() {
        this.subscribeBreadcrumb();
    }

    public ngAfterContentInit() {

        if (this.isBreadcrumbManually()) {
            this.setBreadcrumbManually();
        } else {
            this.setBreadcrumb();
        }
    }

    public handlerRedirectTo(url: any) {

        this.router.navigateByUrl(url);
    }

    private subscribeBreadcrumb() {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd))
            .subscribe((_) => this.setBreadcrumb());
    }

    private setBreadcrumb() {
        let url = '';
        let currentRoute = this.route.root;

        const { hostname } = new URL(this.uri);

        this.breadcrumbs = [{ label: 'Home', url: '/home' }];

        const pathMain = this.uri.split(hostname)[1]
            .split('/')[1];

        do {
            const childrenRoutes = currentRoute.children;

            currentRoute = null;

            childrenRoutes.forEach((route) => {

                if (route.outlet === 'primary' && route.component !== undefined) {

                    // get Bread label and url
                    const path = route.snapshot.url.map((segment) => segment.path)
                        .join('/');

                    url += (path) ? `/${path}` : `/${pathMain}`;

                    if (route.snapshot.data.breadcrumb) {
                        this.breadcrumbs.push({ label: route.snapshot.data.breadcrumb, url });
                    }

                    // get page title
                    const title = route.snapshot.data.title;
                    this.title = (title) ? title : (route.parent.snapshot.data.title) ? route.parent.snapshot.data.title : '';
                }

                currentRoute = route;
            });
        } while (currentRoute);

        this.responsive();
    }

    private setBreadcrumbManually() {
        this.breadcrumbs = [...this.setBreadcrumsbManually];
        this.responsive();
    }

    private isBreadcrumbManually() {
        return this.setBreadcrumsbManually.length > 0;
    }

    private responsive() {
        this.breadLabelCount = this.breadcrumbs.length;

        if (this.breadcrumbs[this.breadLabelCount - 2]) {

            // tslint:disable-next-line:no-string-literal
            this.lastBreadLink = this.breadcrumbs[this.breadLabelCount - 2]['url'];
        }
    }
}
